import vaultCreateComponent from './vault.create.component';

let vaultCreateModule = angular.module('vaultcreate', [
  ])

  .component('vaultcreate', vaultCreateComponent)

  .name;

export default vaultCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/vault/create/index.js